export const ModalWindowArrow = ({width, height, points}) => {
    return (
        <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
            <polygon stroke="#255b66" strokeWidth="4" points={points} fill="#e3f2f5" />
            <polygon points={points} fill="#e3f2f5" />
        </svg>
    );
};
